/** @jsx jsx */
import { jsx } from 'theme-ui';
import PropTypes from 'prop-types';
import { DualColumnContainer } from './dual-column-content-block-css';

const DualColumnContentBlock = ({ backgroundColor, children }) => (
  <DualColumnContainer bg={backgroundColor}>
    {children}
  </DualColumnContainer>
);

DualColumnContentBlock.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default DualColumnContentBlock;
